<template>
  <div class="row box-row">
    <div class="col form-group form-check">
      <input
        :id="'item_' + item.ADDID"
        :type="stockMode ? 'hidden': 'checkbox'"
        class="form-check-input"
        :checked="isSelectedEquipment(item)"
        @change.prevent="toggleEquipment(item)"
      >
      <label
        :for="'item_' + item.ADDID"
        class="box-label form-check-label d-flex justify-content-between"
      >
        <template v-if="!isPackage">
          {{ item.name }}
        </template>
        <template v-else>
          {{ truncatedName }}
          <addition-info v-if="item.name.length > 50">
            {{ item.name }}
          </addition-info>
        </template>
      </label>
    </div>
    <div class="col box-value">
      csomag része
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import _ from 'lodash';
  import {namespace} from 'vuex-class';
  import AdditionInfo from '../AdditionInfo';

  const configuratorModule = namespace('configurator');

  @Component({
    components: {AdditionInfo}
  })
  export default class ExtraEquipmentInPackage extends Vue {
    @Prop(Object) item;

    @configuratorModule.Getter('getEquipmentMonthlyPrice') getEquipmentMonthlyPrice;
    @configuratorModule.Getter('isSelectedEquipment') isSelectedEquipment;
    @configuratorModule.Action('toggleEquipment') toggleEquipment;
    @configuratorModule.State('stockMode') stockMode;

    get isPackage() {
      return _.startsWith(this.item.ADDEQCode, 9)
    }

    get truncatedName() {
      return _.truncate(this.item.name, {length: 50})
    }
  }
</script>
